import { Brain, LineChart, ShieldCheck, Activity, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/components/LanguageContext";
import { useLanguagePath } from "@/utils/language";
import { useAuth } from "@/components/AuthProvider";

export const Hero = () => {
  const { t } = useLanguage();
  const { getPath } = useLanguagePath();
  const { profile } = useAuth();
  const navigate = useNavigate();
  
  const isPtButtonDisabled = profile && !profile.is_trainer;
  const isStudentButtonDisabled = profile?.is_trainer === true;

  const handlePtClick = () => {
    if (!isPtButtonDisabled) {
      navigate(getPath("/auth"));
    }
  };

  const handleStudentClick = () => {
    if (!isStudentButtonDisabled) {
      navigate(getPath("/student-auth"));
    }
  };

  return <div className="relative bg-gradient-to-br from-baby-powder via-slate-gray-light/10 to-slate-gray-light/20 dark:from-gray-900 dark:via-gray-800/30 dark:to-gray-800/20 overflow-hidden">
      {/* Camada de pontos de fundo */}
      <div className="absolute inset-0 w-full h-full z-0" style={{
      backgroundImage: 'radial-gradient(#0000001a 1px, transparent 1px)',
      backgroundSize: '20px 20px'
    }} />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <h1 className="text-4xl font-bold text-black dark:text-white leading-tight sm:text-4xl">
              {t('landing.hero.title')}
            </h1>
            
            <div className="space-y-6">
              <div className="flex items-center gap-3">
                <Brain className="h-6 w-6 text-flame" />
                <p className="text-slate-gray-dark dark:text-gray-300 text-lg">
                  {t('landing.hero.subtitle1')}
                </p>
              </div>
              
              <div className="flex items-center gap-3">
                <LineChart className="h-6 w-6 text-flame" />
                <p className="text-slate-gray-dark dark:text-gray-300 text-lg">
                  {t('landing.hero.subtitle2')}
                </p>
              </div>

              <div className="flex items-center gap-3">
                <Users className="h-6 w-6 text-[#F97316]" />
                <p className="text-slate-gray-dark dark:text-gray-300 text-lg font-bold">
                  {t('landing.hero.unlimitedStudents')}
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                size="lg" 
                className="text-lg px-8 py-6" 
                disabled={isPtButtonDisabled}
                onClick={handlePtClick}
              >
                {t('landing.hero.ptButton')}
              </Button>
              <Button 
                size="lg" 
                variant="outline" 
                className="text-lg px-8 py-6 dark:text-white dark:border-gray-700 dark:hover:bg-gray-800" 
                disabled={isStudentButtonDisabled}
                onClick={handleStudentClick}
              >
                {t('landing.hero.studentButton')}
              </Button>
            </div>

            <div className="bg-baby-powder/80 dark:bg-gray-800/80 backdrop-blur-sm p-6 rounded-xl shadow-ios">
              <div className="flex items-center gap-4">
                <Users className="h-8 w-8 text-flame" />
                <div>
                  <p className="text-3xl font-bold text-black dark:text-white">+1000</p>
                  <p className="text-slate-gray-light dark:text-gray-400">{t('landing.hero.activeStudents')}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="backdrop-blur rounded-2xl p-6 space-y-6 bg-baby-powder/80 dark:bg-gray-800/80 hover:bg-baby-powder/90 dark:hover:bg-gray-800/90 transition-colors shadow-ios">
              
              <h2 className="text-xl text-slate-gray-dark dark:text-gray-300">{t('landing.hero.aiSection.title')}</h2>
              
              <ul className="space-y-4">
                <li className="flex items-center gap-2">
                  <ShieldCheck className="h-5 w-5 text-flame" />
                  <span className="text-slate-gray-dark dark:text-gray-300">{t('landing.hero.aiSection.feature1')}</span>
                </li>
                <li className="flex items-center gap-2">
                  <Brain className="h-5 w-5 text-flame" />
                  <span className="text-slate-gray-dark dark:text-gray-300">{t('landing.hero.aiSection.feature2')}</span>
                </li>
                <li className="flex items-center gap-2">
                  <Activity className="h-5 w-5 text-flame" />
                  <span className="text-slate-gray-dark dark:text-gray-300">{t('landing.hero.aiSection.feature3')}</span>
                </li>
              </ul>

              <img src="/lovable-uploads/f4192537-4d80-4052-b1d3-7745abba72c9.png" alt="Personal trainer exibindo aplicação no tablet" className="rounded-lg shadow-ios" />
            </div>
          </div>
        </div>
      </div>
    </div>;
};
